import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
var initHeroSwiper = function initHeroSwiper() {
  var swiper = document.querySelector('.maloka-dynamic-hero__slider.swiper');
  if (swiper) {
    var swiperInstance = new Swiper(swiper, {
      loop: false,
      modules: [Navigation, Pagination],
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
};
export default initHeroSwiper;